export type CastScale = '2_step' | '3_step' | '5_step';
export type SurveyQuestionVariant = 'need_more_help' | 'anything_else_help' | 'anything_else_do';

export type SurveySettingsDto = {
  popup_after_messages: number | null;
  popup_after_minutes: number | null;
  cast_scale: CastScale;
  question_variant: SurveyQuestionVariant;
};

export type UpdateSurveySettingsDto = Partial<SurveySettingsDto>;

export const SURVEY_OFF_SENTINEL = 'off';

export const POPUP_AFTER_MESSAGES_OPTIONS = [2, 4, 6] as const;
export const POPUP_AFTER_MINUTES_OPTIONS = [5, 10, 20] as const;
export const CAST_SCALE_OPTIONS: CastScale[] = ['2_step', '3_step', '5_step'];
export const QUESTION_VARIANT_OPTIONS: SurveyQuestionVariant[] = [
  'need_more_help',
  'anything_else_help',
  'anything_else_do',
];
